var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { global, uuid, isBrowser } from '@planjs/utils';
var DEV_SID_KEY = 'pin-device-id';
var BETA_ENV_KEY = '__use_pin_beta_env__';
function getDevSid() {
    if (isBrowser()) {
        var uid = '';
        var _uuid = window.localStorage.getItem(DEV_SID_KEY);
        if (_uuid) {
            uid = _uuid;
        }
        else {
            uid = uuid();
            window.localStorage.setItem(DEV_SID_KEY, uid);
        }
        return uid;
    }
    // 适配其他环境
    return uuid();
}
/**
 * 获取 nonceId 每次路由变化都会重新生成
 * 仅浏览器环境生效
 */
function handleNonceId() {
    global.env.nonceId = uuid();
    if (isBrowser()) {
        var URIChange = function () {
            global.env.nonceId = uuid();
        };
        window.addEventListener('hashchange', URIChange);
        window.addEventListener('pushState', URIChange);
        window.addEventListener('replaceState', URIChange);
    }
}
/**
 * 设置 beta 的全局变量
 * 仅浏览器环境生效
 */
function handleBetaENV() {
    if (isBrowser()) {
        // @ts-ignore
        window[BETA_ENV_KEY] = !!+window.localStorage.getItem(BETA_ENV_KEY);
        global['env'].goBetaENV = function () {
            window.localStorage.setItem(BETA_ENV_KEY, '1');
            window.location.reload();
        };
        global['env'].exitBetaENV = function () {
            window.localStorage.removeItem(BETA_ENV_KEY);
            window.location.reload();
        };
    }
}
export function install(env) {
    if (!global.env) {
        global['env'] = {};
    }
    Object.assign(global.env, env);
    // mounted dev sid
    global.env.deviceSid = getDevSid();
    // default server date
    global.env.serverDate = Math.floor(Date.now() / 1000);
    // default uint
    global.env.dateDifference = '0';
    // nonce
    handleNonceId();
    // beta env
    handleBetaENV();
    // seal env
    Object.seal(global.env);
    return __assign({}, global.env);
}
